import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import { Stack, xcss, Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

export const messages = defineMessages({
	standardColumnTitle: {
		id: 'experiment-aua-improve-conversion.standard-edition-column.title',
		defaultMessage: 'Standard',
		description:
			'Title of the standard edition column in the free to standard feature comparison table.',
	},
});

export const StandardEditionColumn = () => {
	const { formatMessage } = useIntl();

	return (
		<Stack xcss={standardEditionColumnStyles} alignInline="center" space="space.200">
			<Stack alignInline="center">
				<Text size="medium" as="strong">
					{formatMessage(messages.standardColumnTitle)}
				</Text>
			</Stack>
			<Stack space="space.200" xcss={CheckCircleIconContainerStyles}>
				<CheckCircleIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
				<CheckCircleIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
				<CheckCircleIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
				<CheckCircleIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
				<CheckCircleIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
				<CheckCircleIcon spacing="spacious" label="" color={token('color.icon.accent.green')} />
			</Stack>
		</Stack>
	);
};

const standardEditionColumnStyles = xcss({
	width: '90px',
	height: '330px',
	backgroundColor: 'color.background.input',
	borderRadius: '3px',
	borderWidth: '1px',
	paddingTop: 'space.300',
	boxShadow: 'elevation.shadow.overlay',
	zIndex: 'spotlight',
});

const CheckCircleIconContainerStyles = xcss({
	paddingTop: 'space.0',
});
